import { Content, FormattedProps } from './types';
import { formatSubscriptionOptions } from '../shared/propsFormatter';
import { PropsFormatterUtils } from 'shared/types';

export const getFormattedApis = (content: Content): FormattedProps['apis'] => ({
  registerSubscriptionUpgrade: {
    url: content.apis?.register_subscription_upgrade?.url ?? '',
    method: content.apis?.register_subscription_upgrade?.method || 'POST'
  },
  getAvailableProposals: {
    url: content.apis?.get_available_proposals?.url ?? '',
    method: content.apis?.get_available_proposals?.method || 'GET'
  },
  retrieveOffersByProposals: {
    url: content.apis?.retrieve_offers_by_proposals?.url ?? '',
    method: content.apis?.retrieve_offers_by_proposals?.method || 'POST'
  },
  getSubscriberData: {
    url: content.apis?.getSubscriberData?.url ?? '',
    method: content.apis?.getSubscriberData?.method ?? 'GET',
    parameters: content.apis?.getSubscriberData?.parameters || {}
  }
});

export default (
  content: Content,
  { getLinkHrefWithAuthentication }: PropsFormatterUtils
): FormattedProps => ({
  title: content.title.label,
  subscriptionOptions: formatSubscriptionOptions(
    content.subscriptionOptions || []
  ),
  titleHtmlTag: content.title.htmlTag,
  summaryTosAgreementText: content.summaryTosAgreementText ?? '',
  redirectPopinText: content.redirectPopinText ?? '',
  redirectPopinLinkLabel: content.redirectPopinLinkLabel ?? '',
  redirectPopinUrl: getLinkHrefWithAuthentication(
    content.redirectPopinLink ?? ''
  ),
  confirmationButtonLabel: content.buttons?.confirmationButton?.label ?? '',
  apis: getFormattedApis(content)
});
